export const VALUES = {
  timelineAvatarSize: 32,
  timelineBackPageSize: 15,
  loadAroundHighlightedPageSize: 3,
  rowLoadingSkeletonCount: 5,
  maxLinkedBranches: 5,
  maxLinkedPullRequests: 25,
  issueTransferRepositoriesPreloadCount: 10,
  ghostUserLogin: 'ghost',
  branchUrl: (branch: string, repositoryWithOwner: string) => `/${repositoryWithOwner}/tree/${branch}`,
}
